import {management} from '../../../index';
import moment from "moment";

export class MonitoringSectorHelpers {
  whereClauseToCrop = `(DATE_CROP = '' OR DATE_CROP >= DATE(NOW()))`;

  async getSectorsManagementLength() {
    const raw = `
      SELECT COUNT(*) SECTORS_COUNT
      FROM CROP.CAD_SECTOR
      WHERE ${this.whereClauseToCrop};
    `;
  
    return (await 
      management.sql({
        data: {
          sql: raw
        }
      })
      .then( val => val && val [0] && val[0][0] ? val[0][0].SECTORS_COUNT || 0 : 0 )
    );
  }

  async getSectorsManagementCropedLength() {
    const raw = `
      SELECT COUNT(*) SECTORS_COUNT
      FROM CROP.CAD_SECTOR
      WHERE NOT ${this.whereClauseToCrop};
    `;
  
    return (await 
      management.sql({
        data: {
          sql: raw
        }
      })
      .then( val => val && val [0] && val[0][0] ? val[0][0].SECTORS_COUNT || 0 : 0 )
    );
  }

  async getInactiveSectorsLength() {
    const raw = `
      SELECT COUNT(*) SECTORS_COUNT
      FROM NEWSIR.CAD_SECTOR NEWSIR_SECTOR
      LEFT JOIN CROP.CAD_SECTOR CROP_SECTOR
      ON CROP_SECTOR.ID_SECTOR = NEWSIR_SECTOR.ID
      WHERE ISNULL(CROP_SECTOR.ID_SECTOR)
    `;
  
    return (await 
      management.sql({
        data: {
          sql: raw
        }
      })
      .then( val => val && val [0] && val[0][0] ? val[0][0].SECTORS_COUNT || 0 : 0 )
    );
  }
  
  async getInactiveSectorsBasic() {
    const raw = `
      SELECT
        NEWSIR_SECTOR.*,
        NEWSIR_SECTOR.ID ID_SECTOR,
        CAD_USER.NAME EDITOR_NAME
      FROM NEWSIR.CAD_SECTOR NEWSIR_SECTOR
      LEFT JOIN CROP.CAD_SECTOR CROP_SECTOR
      ON CROP_SECTOR.ID_SECTOR = NEWSIR_SECTOR.ID
      LEFT JOIN NEWSIR.CAD_USER CAD_USER
      ON CAD_USER.ID = NEWSIR_SECTOR.FK_EDITOR
      WHERE ISNULL(CROP_SECTOR.ID_SECTOR)
      ORDER BY NEWSIR_SECTOR.NAME;
    `;
  
    return (await 
      management.sql({
        data: {
          sql: raw
        }
      })
      .then( val => val && val [0] && val[0] ? val[0] : [] )
      .then(sectors => {
        return sectors.map(sector => {
          sector.FARM = {
            NAME: sector.PLANTING_TYPE || '...'
          }

          sector.inative_days = Math.ceil(moment().diff(moment(sector.UPDATE).format("YYYY-MM-DD"), 'days'))

          return sector;
        })
      })
    );
  }
  
  async getManagementSectorsBasic() {
    const raw = `
      SELECT
        NEWSIR_SECTOR.*,
        NEWSIR_SECTOR.ID ID_SECTOR,
        FARM.NAME FARM_NAME,
        CAD_USER.NAME EDITOR_NAME
      FROM NEWSIR.CAD_SECTOR NEWSIR_SECTOR
      LEFT JOIN CROP.CAD_SECTOR CROP_SECTOR
      ON CROP_SECTOR.ID_SECTOR = NEWSIR_SECTOR.ID
      LEFT JOIN NEWSIR.CAD_USER CAD_USER
      ON CAD_USER.ID = NEWSIR_SECTOR.FK_EDITOR
      LEFT JOIN CROP.FARM FARM
      ON FARM.ID = CROP_SECTOR.ID_FARM
      WHERE ${this.whereClauseToCrop} AND NOT(ISNULL(CROP_SECTOR.ID_SECTOR))
      ORDER BY NEWSIR_SECTOR.NAME;
    `;
  
    return (await 
      management.sql({
        data: {
          sql: raw
        }
      })
      .then( val => val && val [0] && val[0] ? val[0] : [] )
      .then(sectors => {
        return sectors.map(sector => {
          sector.FARM = {
            NAME: sector.FARM_NAME
          }

          return sector;
        })
      })
    );
  }
  
  async getCropedSectorsBasic() {
    const raw = `
      SELECT
        NEWSIR_SECTOR.*,
        NEWSIR_SECTOR.ID ID_SECTOR,
        FARM.NAME FARM_NAME,
        CAD_USER.NAME EDITOR_NAME
      FROM NEWSIR.CAD_SECTOR NEWSIR_SECTOR
      LEFT JOIN CROP.CAD_SECTOR CROP_SECTOR
      ON CROP_SECTOR.ID_SECTOR = NEWSIR_SECTOR.ID
      LEFT JOIN NEWSIR.CAD_USER CAD_USER
      ON CAD_USER.ID = NEWSIR_SECTOR.FK_EDITOR
      LEFT JOIN CROP.FARM FARM
      ON FARM.ID = CROP_SECTOR.ID_FARM
      WHERE NOT ${this.whereClauseToCrop} AND NOT(ISNULL(CROP_SECTOR.ID_SECTOR))
      ORDER BY NEWSIR_SECTOR.NAME;
    `;
  
    return (await 
      management.sql({
        data: {
          sql: raw
        }
      })
      .then( val => val && val [0] && val[0] ? val[0] : [] )
      .then(sectors => {
        return sectors.map(sector => {
          sector.FARM = {
            NAME: sector.FARM_NAME
          }

          return sector;
        })
      })
    );
  }

  async getSectorsManagementActuators({limit, offset}) {
    const raw = `
      SELECT CAD_VALVE.NAME
      FROM (
        SELECT *
        FROM CROP.CAD_SECTOR
        WHERE ${this.whereClauseToCrop}
        LIMIT ${limit} OFFSET ${offset}
        ) CROP_SECTOR
      JOIN NEWSIR.CAD_SECTOR NEWSIR_SECTOR
      ON (
        NEWSIR_SECTOR.ID = CROP_SECTOR.ID_SECTOR
        AND CROP_SECTOR.IS_MANAGEMENT = 1
        AND IF(CROP_SECTOR.DATE_CROP = '', TRUE, CROP_SECTOR.DATE_CROP >= DATE(NOW()))
      )
      JOIN NEWSIR.SECTOR_HAS_VALVE SECTOR_HAS_VALVE
      ON SECTOR_HAS_VALVE.ID_SECTOR = NEWSIR_SECTOR.ID
      JOIN NEWSIR.CAD_VALVE CAD_VALVE
      ON CAD_VALVE.ID = SECTOR_HAS_VALVE.ID_VALVE
      WHERE CAD_VALVE.NAME IN (
        SELECT TABLE_NAME
        FROM INFORMATION_SCHEMA.TABLES
        WHERE TABLE_TYPE = 'BASE TABLE' && TABLE_SCHEMA = 'LOG_ACTUATOR'
      )
      GROUP BY CAD_VALVE.NAME;
    `;

    const actuators = (await management.sql({
      data: {
        sql: raw
      }
    }))[0];

    return actuators && actuators.length ?
      actuators.map(act => act.NAME) :
      [];
  }

  unionAVGActuators(actuators){
    let unionOfActuatorsTablesQuery = "";

    for(const [index, actuator] of actuators.entries()) {
      let flowAvgOfActuatorQuery = `
        SELECT
            FK_EQP,
            IFNULL(AVG(FLOW), 0) AS FLOW
        FROM LOG_ACTUATOR.\`${actuator}\`
        WHERE (
              DATE(TIME) <= DATE_ADD(DATE(NOW()), INTERVAL -1 DAY)
              AND DATE(TIME) >= DATE_ADD(DATE(NOW()), INTERVAL -15 DAY)
              AND FLOW > 0
              AND OPEN = 1
        )`;

      unionOfActuatorsTablesQuery += flowAvgOfActuatorQuery;

      if(index != actuators.length - 1) {
        unionOfActuatorsTablesQuery += '\nUNION ALL';
      }
    }

    return unionOfActuatorsTablesQuery;
  }

  async showManagementSectors({ page, limit, isCroped = false}) {
    limit = limit ? limit : 50; 
    page = page ? page : 1; 
    const offset = (page - 1 ) * limit;

    let unionOfActuatorsTablesQuery = "";

    if(!isCroped) {
      unionOfActuatorsTablesQuery = this.unionAVGActuators(await this.getSectorsManagementActuators({limit, offset, isCroped}));
    }

    let raw = `
      SELECT
        NEWSIR_SECTOR.ID AS ID_SECTOR,
        NEWSIR_SECTOR.NAME,
        NEWSIR_SECTOR.AREA,
        NEWSIR_SECTOR.PLANTING_TYPE,
        NEWSIR_SECTOR.PLANTING_DATE,
        NEWSIR_SECTOR.FLOW,
        NEWSIR_SECTOR.NOTE,
        NEWSIR_SECTOR.UPDATE,
        C_USER.NAME AS EDITOR_NAME,
        AGN_INFOS.SCHEDULE_NAME AS SCHEDULE_NAME,
        AGN_INFOS.TIME as SCHEDULE_DURATION,
        ${unionOfActuatorsTablesQuery ? 'AGN_INFOS.TIME/60 * ACTUATORS.FLOW' : 0} AS SCHEDULE_VOLUME_PREVIEW,
        MANAGEMENT.TIME,
        IF (MANAGEMENT.TIME = NEWSIR_SECTOR.PLANTING_DATE, FARM.LAMINA, MANAGEMENT.BLADE_SUGGESTION) as BLADE_SUGGESTION,
        ${unionOfActuatorsTablesQuery ? 'ACTUATORS.FLOW' : 0} AS FLOW_AVG,
        MANAGEMENT.PLANT_OCCUPANCY_SPACE,
        MANAGEMENT.KL_FACTOR,
        MANAGEMENT.VOLUME,
        MANAGEMENT.RAINFALL,
        MANAGEMENT.RAINFALL_INPUT,
        IFNULL(MANAGEMENT.ID_DAP, 0) AS ID_DAP,
        MANAGEMENT.MAX_STORAGE,
        MANAGEMENT.IRRIGATED_BLADE,
        MANAGEMENT.ETC,
        MANAGEMENT.INITIAL_STORAGE,
        MANAGEMENT.KS,
        MANAGEMENT.ETR,
        MANAGEMENT.ETR_PREDICTION,
        MANAGEMENT.ET0,
        MANAGEMENT.ET0_PREDICTION,
        MANAGEMENT.FINAL_STORAGE,
        MANAGEMENT.EXCESS,
        MANAGEMENT.NEGATIVE_ACCUMULATED,
        MANAGEMENT.WATER_DISPONIBILITY,
        CROP_SECTOR.DATE_CROP,
        CROP_SECTOR.VOLUME_DATE,
        CROP_SECTOR.IS_MANAGEMENT,
        CROP_SECTOR.PRESSURIZE_TIME,
        CROP_SECTOR.TIME_ADVANCE,
        CROP_SECTOR.AVG_TIME_PULSE,
        CROP_SECTOR.APPLICATION_RATE,
        CROP_SECTOR.SYSTEM_EFFICIENCY,
        CROP_SECTOR.SPACING_BETWEEN_PLANTS,
        CROP_SECTOR.SPACING_BETWEEN_LINES,
        FARM.NAME FARM_NAME,
        FARM.LAMINA,
        FARM.NOTE FARM_NOTE,
        SOIL.NAME SOIL_NAME,
        SOIL.TRANSMISSIVITY,
        SOIL.FIELD_CAPACITY,
        SOIL.WILT_POINT,
        SOIL.DENSITY,
        SOIL.ID ID_SOIL,
        CROP_SECTOR.ID_FARM,
        SECTORS_VALVE.ID_VALVE,
        (SELECT
          COUNT(*) > 0
        FROM NEWSIR.SECTOR_HAS_SENSOR SENSORS
        LEFT JOIN NEWSIR.CAD_SENSOR CS
        ON CS.ID = SENSORS.ID_SENSOR 
        LEFT JOIN NEWSIR.CAD_MODEL_SENSOR CMS
        ON CMS.ID = CS.FK_MODEL 
        WHERE SENSORS.ID_SECTOR = NEWSIR_SECTOR.ID AND CMS.NAME IN ('GS1', 'GS3', 'TEROS10', 'TEROS12', 'STU-S')) HAS_SENSOR,
        CAD_VALVE.NAME ACTUATOR_NAME,
        CAD_VALVE.NAME IN (
          SELECT TABLE_NAME
          FROM INFORMATION_SCHEMA.TABLES
          WHERE TABLE_TYPE = 'BASE TABLE' && TABLE_SCHEMA = 'LOG_ACTUATOR'
        ) VALID_ACTUATOR,
        FARMS_DAP.PRECIPITATION,
        FARMS_DAP.KC,
        FARMS_DAP.STRESS,
        FARMS_DAP.BRANCH,
        FARMS_DAP.DEPTH_ROOT,
        FARMS_DAP.AVAILABILITY
  FROM (
    SELECT *
    FROM CROP.CAD_SECTOR
    WHERE ${isCroped ? 'NOT ' : ''}${this.whereClauseToCrop}
    LIMIT ${limit} OFFSET ${offset}
  ) CROP_SECTOR
    LEFT JOIN NEWSIR.CAD_SECTOR NEWSIR_SECTOR
    ON CROP_SECTOR.ID_SECTOR = NEWSIR_SECTOR.ID
    LEFT JOIN CROP.SOIL SOIL
    ON CROP_SECTOR.ID_SOIL = SOIL.ID
    LEFT JOIN CROP.FARM FARM
    ON FARM.ID = CROP_SECTOR.ID_FARM
    LEFT JOIN CROP.MANAGEMENT MANAGEMENT
    ON (
      MANAGEMENT.ID_SECTOR = CROP_SECTOR.ID_SECTOR
      AND MANAGEMENT.TIME = (
          SELECT
            IF(CROP_SECTOR.DATE_CROP = "" OR CROP_SECTOR.DATE_CROP > MAX(TIME) , MAX(TIME), CROP_SECTOR.DATE_CROP) TIME
          FROM CROP.MANAGEMENT m
          WHERE m.ID_SECTOR = NEWSIR_SECTOR.ID
        )
    )
    LEFT JOIN CROP.FARMS_DAP FARMS_DAP
    ON (
      FARMS_DAP.ID_FARM = CROP_SECTOR.ID_FARM
      AND MANAGEMENT.ID_DAP = FARMS_DAP.DAP
    )
    INNER JOIN NEWSIR.SECTOR_HAS_VALVE as SECTORS_VALVE
    ON SECTORS_VALVE.ID_SECTOR = NEWSIR_SECTOR.ID
    LEFT JOIN NEWSIR.CAD_VALVE CAD_VALVE
    ON CAD_VALVE.ID = SECTORS_VALVE.ID_VALVE
    LEFT JOIN (
      SELECT
        SUM(TIME) TIME,
        NAME,
        FK_VALVE,
        NAME SCHEDULE_NAME
      FROM NEWSIR.AGN_VALVE
      JOIN NEWSIR.AGN_DURATION AGN_DURATION
      ON AGN_DURATION.ID = AGN_VALVE.FK_DURATION
      JOIN NEWSIR.AGN_TIME AGN_TIME
      ON (
        AGN_TIME.ID = AGN_VALVE.FK_AGN
        -- CHECK IF TODAY IS BETWEEN SCHEDULE DAYS RUNNING
        AND DATE(AGN_TIME.START_DATE) <= DATE(NOW())
        AND IF(ISNULL(AGN_TIME.END_DATE), TRUE, DATE(AGN_TIME.END_DATE) >= DATE(NOW()))
        AND (AGN_TIME.ACTIVITY_DAYS & POWER(2, (DAYOFWEEK(NOW()) - 1 ))) =  POWER(2, (DAYOFWEEK(NOW()) - 1 ))
      )
      GROUP BY FK_VALVE
    ) AGN_INFOS
    ON AGN_INFOS.FK_VALVE = SECTORS_VALVE.ID_VALVE
    ${unionOfActuatorsTablesQuery ? `LEFT JOIN (${unionOfActuatorsTablesQuery}
      ) ACTUATORS
      ON ACTUATORS.FK_EQP = CAD_VALVE.ID` : ''}
    LEFT JOIN NEWSIR.CAD_USER AS C_USER
    ON NEWSIR_SECTOR.FK_EDITOR = C_USER.ID
    LEFT JOIN NEWSIR.SECTOR_HAS_SENSOR SECTOR_HAS_SENSOR
    ON SECTOR_HAS_SENSOR.ID_SECTOR = NEWSIR_SECTOR.ID
    LEFT JOIN NEWSIR.CAD_SENSOR CAD_SENSOR
    ON CAD_SENSOR.ID = SECTOR_HAS_SENSOR.ID_SENSOR
    LEFT JOIN NEWSIR.CAD_MODEL_SENSOR CAD_MODEL_SENSOR
    ON CAD_SENSOR.FK_MODEL = CAD_MODEL_SENSOR.ID
    GROUP BY NEWSIR_SECTOR.ID
    ORDER BY NEWSIR_SECTOR.NAME;
  `;

  const management_sectors = await management.sql({
    data: {
      sql: raw
    }
  });

    let managementSectorsJoinedWithNewsirSectors = [];

    if (management_sectors[0] && management_sectors[0].length) {
      //DTO
      managementSectorsJoinedWithNewsirSectors = management_sectors[0].map(
        sector => {
          const {
            ID_SECTOR,
            NAME,
            DATE_CROP,
            HAS_SENSOR,
            VOLUME_DATE,
            OFFSET_DAP,
            IS_MANAGEMENT,
            PRESSURIZE_TIME,
            TIME_ADVANCE,
            AVG_TIME_PULSE,
            APPLICATION_RATE,
            SYSTEM_EFFICIENCY,
            SPACING_BETWEEN_PLANTS,
            SPACING_BETWEEN_LINES,
            SCHEDULE_NAME,
            SCHEDULE_DURATION,
            SCHEDULE_VOLUME_PREVIEW,
            PLANTING_TYPE,
            AREA,
            ID_SOIL,
            ID_FARM,
            UPDATE,
            EDITOR_NAME,
            PLANTING_DATE,
            NOTE,
            ID_VALVE,
            ACTUATOR_NAME,
            VALID_ACTUATOR,
            FLOW_AVG,
            ...MANAGEMENT_DETAILS
          } = sector;

          const SCHEDULE = {
            SCHEDULE_NAME,
            SCHEDULE_DURATION,
            SCHEDULE_VOLUME_PREVIEW
          }

          const SOIL = {
            ID: ID_SOIL,
            NAME: MANAGEMENT_DETAILS.SOIL_NAME,
            TRANSMISSIVITY: MANAGEMENT_DETAILS.TRANSMISSIVITY,
            FIELD_CAPACITY: MANAGEMENT_DETAILS.FIELD_CAPACITY,
            WILT_POINT: MANAGEMENT_DETAILS.WILT_POINT,
            DENSITY: MANAGEMENT_DETAILS.DENSITY,
            NOTE: "SOLO TESTE"
          };
          const FARM = {
            ID: ID_FARM,
            NAME: MANAGEMENT_DETAILS.FARM_NAME,
            LAMINA: MANAGEMENT_DETAILS.LAMINA,
            NOTE: MANAGEMENT_DETAILS.FARM_NOTE
          };

          const MANAGEMENT = {
            TIME: MANAGEMENT_DETAILS.TIME,
            PRECIPITATION: MANAGEMENT_DETAILS.PRECIPITATION,
            STRESS: MANAGEMENT_DETAILS.STRESS,
            KC: MANAGEMENT_DETAILS.KC,
            BRANCH: MANAGEMENT_DETAILS.BRANCH,
            DEPTH_ROOT: MANAGEMENT_DETAILS.DEPTH_ROOT,
            AVAILABILITY: MANAGEMENT_DETAILS.AVAILABILITY,
            PLANT_OCCUPANCY_SPACE: MANAGEMENT_DETAILS.PLANT_OCCUPANCY_SPACE,
            KL_FACTOR: MANAGEMENT_DETAILS.KL_FACTOR,
            VOLUME: MANAGEMENT_DETAILS.VOLUME,
            RAINFALL: MANAGEMENT_DETAILS.RAINFALL,
            RAINFALL_INPUT: MANAGEMENT_DETAILS.RAINFALL_INPUT,
            MAX_STORAGE: MANAGEMENT_DETAILS.MAX_STORAGE,
            IRRIGATED_BLADE: MANAGEMENT_DETAILS.IRRIGATED_BLADE,
            ETC: MANAGEMENT_DETAILS.ETC,
            INITIAL_STORAGE: MANAGEMENT_DETAILS.INITIAL_STORAGE,
            KS: MANAGEMENT_DETAILS.KS,
            ETR: MANAGEMENT_DETAILS.ETR,
            ETR_PREDICTION: MANAGEMENT_DETAILS.ETR_PREDICTION,
            ET0: MANAGEMENT_DETAILS.ET0,
            ET0_PREDICTION: MANAGEMENT_DETAILS.ET0_PREDICTION,
            FINAL_STORAGE: MANAGEMENT_DETAILS.FINAL_STORAGE,
            EXCESS: MANAGEMENT_DETAILS.EXCESS,
            NEGATIVE_ACCUMULATED: MANAGEMENT_DETAILS.NEGATIVE_ACCUMULATED,
            BLADE_SUGGESTION: MANAGEMENT_DETAILS.BLADE_SUGGESTION,
            WATER_DISPONIBILITY: MANAGEMENT_DETAILS.WATER_DISPONIBILITY,
            ID_DAP: MANAGEMENT_DETAILS.ID_DAP
          };

          return {
            ID_SECTOR,
            FLOW_AVG,
            ID_VALVE,
            ACTUATOR_NAME,
            VALID_ACTUATOR,
            NAME,
            DATE_CROP,
            HAS_SENSOR,
            VOLUME_DATE,
            OFFSET_DAP,
            PLANTING_DATE,
            NOTE,
            IS_MANAGEMENT: IS_MANAGEMENT === 1 ? true : false,
            PRESSURIZE_TIME,
            TIME_ADVANCE,
            AVG_TIME_PULSE,
            APPLICATION_RATE,
            SYSTEM_EFFICIENCY,
            SPACING_BETWEEN_PLANTS,
            SPACING_BETWEEN_LINES,
            PLANTING_TYPE,
            AREA,
            UPDATE,
            EDITOR_NAME,
            SOIL,
            FARM,
            MANAGEMENT,
            SCHEDULE
          };
        }
      );
    }

    return managementSectorsJoinedWithNewsirSectors;
  }
}


